// extracted by mini-css-extract-plugin
export default {"sobre":"Sobre_sobre__Sg76-"};